import { z } from 'zod';

// Mirrors the backend RegisterRequest. `passwordConfirm` is a client-only
// check and is stripped before the request is sent.
export const registerSchema = z
  .object({
    name: z.string().trim().min(1, 'Enter your name.').max(255),
    email: z.email('Enter a valid email address.').max(255),
    password: z.string().min(8, 'Password must contain at least 8 characters.'),
    passwordConfirm: z.string(),
    phone: z.string().trim().min(1, 'Enter your phone number.').max(32),
    address: z.string().trim().min(1, 'Enter your address.').max(255),
    city: z.string().trim().min(1, 'Enter your city.').max(120),
    country: z.string().trim().min(1, 'Enter your country.').max(120),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    path: ['passwordConfirm'],
    message: 'Passwords do not match.',
  });
